var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Generic_Icon_Layer_1",
    "data-name": "Generic Icon Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".generic-cls-1{fill:#05b2ae;}.generic-cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "generic-cls-1",
    cx: 14.5,
    cy: 14.5,
    r: 14.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "generic-cls-2",
    d: "M74.66,61.44a3.15,3.15,0,0,1,3.17,3.14v3.6a3.17,3.17,0,0,1-3.17,3.16H69.79v1.5H66.45V71.15A3.15,3.15,0,0,1,69.59,68h4.92V64.75H64.34V61.44ZM66.45,77.82V74.5h3.34v3.32Z",
    transform: "translate(-56 -54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.33e79f42819d47ecccec4128533b2210.svg";
export { ForwardRef as ReactComponent };